module.exports = __webpack_public_path__ + "static/ENJ-ee7847274304ffbb9bf0789140d0440b.svg";